<template>
<div>
  <h5 class="text-center">Por favor preencha os dados pessoais do cliente.</h5>
  <div class="row">
    <div class="col-md-10 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Nome do Titular da Conta</label>
        <input
          class="form-control"
          type="text"
          name="holder"
          v-validate="modelValidations.personalData.holder"
          v-model.trim="model.holder"
        />
        <small
          class="text-danger"
          v-show="holder.invalid"
        > {{ getError('holder') }}
        </small>
      </div>
    </div>
    <div class="col-md-10 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Também conhecido como</label>
        <input
          class="form-control"
          type="text"
          name="aka"
          v-validate="modelValidations.personalData.aka"
          v-model.trim="model.aka"
        />
        <small
          class="text-danger"
          v-show="aka.invalid"
        > {{ getError('aka') }}
        </small>
      </div>
    </div>

    <div class="col-md-10 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Nome da mãe</label>
        <input
          class="form-control"
          type="text"
          name="aka"
          v-validate="modelValidations.personalData.motherName"
          v-model.trim="model.motherName"
        />
        <small
          class="text-danger"
          v-show="modelValidations.personalData.motherName.invalid"
        >
          {{ getError('modelValidations.personalData.motherName') }}
        </small>
      </div>
    </div>

    <div class="col-md-10 col-md-offset-1" v-if="config.register.carrer">
      <div class="form-group">
        <label class="control-label">Profissão</label>
        <input
          class="form-control"
          type="text"
          name="carrer"
          v-model.trim="model.carrer"
        />
      </div>
      <div class="form-group">
        <label class="control-label">Possui cargo político?</label>
        <YesNoRadio v-model="model.politician"/>
      </div>
    </div>

    <div class="col-md-10 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Registro Geral (RG)</label>
        <input
          class="form-control"
          type="text"
          name="nationalId"
          v-validate="modelValidations.personalData.nationalId"
          v-model.trim="model.nationalId"
          @keyup="onlyNumber('nationalId')"
        />
        <small
          class="text-danger"
          v-show="nationalId.invalid"
        > {{ getError('nationalId') }}
        </small>
      </div>
    </div>
    <div class="col-md-10 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Data de nascimento</label>
        <input
          class="form-control"
          type="text"
          name="birthdate"
          v-validate="modelValidations.personalData.birthdate"
          v-model.trim="model.birthdate"
          v-mask="'00/00/0000'"
        />
        <small
          class="text-danger"
          v-show="birthdate.invalid"
        > {{ getError('birthdate') }}
        </small>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-5 col-md-offset-1">
      <div class="form-group">
        <label class="control-label">Telefone 1</label>
        <input
          class="form-control"
          type="text"
          name="phone1"
          v-validate="modelValidations.personalData.phone1"
          v-model.trim="model.phone1"
          v-mask-phone.br
        />
        <small
          class="text-danger"
          v-show="phone1.invalid"
        > {{ getError('phone1') }}
        </small>
      </div>
    </div>
    <div class="col-md-5">
      <div class="form-group">
        <label class="control-label">Telefone 2</label>
        <input
          class="form-control"
          type="text"
          name="phone2"
          v-validate="modelValidations.personalData.phone2"
          v-model.trim="model.phone2"
          v-mask-phone.br
        />
        <small
          class="text-danger"
          v-show="phone2.invalid"
        > {{ getError('phone2') }}
        </small>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-5 col-md-offset-1">
      <div class="form-group">
        <label
          class="control-label"
        >
          Método de Regularização
        </label>
        <SelectRegularizationMethod v-model="model.regularity"/>
      </div>
    </div>
    <div class="col-md-5">
      <InputNis v-model="model.nis" />
    </div>
  </div>
</div>
</template>
<script>
import {mapFields} from 'vee-validate'
import {mapGetters, mapActions} from 'vuex'
import YesNoRadio from '../../../components/Trg/YesNoRadio'
import SelectRegularizationMethod from '../../../components/Trg/Customer/SelectRegularizationMethod'
import InputNis from '../../../components/Trg/Customer/InputNis'

export default {
  name: 'PersonalDataForm',
  components: {
    SelectRegularizationMethod,
    InputNis,
    YesNoRadio
  },
  computed: {
    ...mapFields([
      'holder',
      'aka',
      'phone1',
      'phone2',
      'nationalId',
      'birthdate',
      'motherName',
      'nis',
      'regularity',
      'carrer',
      'politician'
    ]),
    ...mapGetters('customers', {
      model: 'customer',
      modelValidations: 'validations',
      loading: 'loading'
    }),
    ...mapGetters('project', {
      config: 'project',
      loading: 'loading'
    })
  },
  mounted () {
    if (this.editing) {
      this.fetchOne(this.id)
    } else {
      this.resetOne()
    }
  },
  methods: {
    ...mapActions('customers', [
      'fetchOne',
      'resetOne',
      'insert',
      'update'
    ]),
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      return this.$validator.validateAll()
    },
    onlyNumber (text) {
      this.model[text] = this.model[text].replace(/\D/g, '')
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Customers/Forms/PersonalDataForm.vue